import { type ReactNode } from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowRight02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { cx } from "shared/utils/classnames";
import { useInboxEmbed } from "../context/useInboxEmbed";

const ROUTING_FIELD_MIN_WIDTH = "min-w-[250px]";

export const RoutingFieldsRow = ({
  from,
  to
}: {
  from: ReactNode;
  to: ReactNode;
}) => {
  // Inside the 400px message pop-up (CRM-1133) two fixed 250px fields plus the
  // labels and arrow overflow the card, so there both fields share the row
  // instead of claiming the /inbox footprint.
  const isCompact = Boolean(useInboxEmbed()?.compact);
  const groupClass = cx(
    "flex items-center gap-2 text-sm",
    isCompact ? "min-w-0 flex-1" : ""
  );
  const fieldClass = isCompact ? "min-w-0 flex-1" : ROUTING_FIELD_MIN_WIDTH;

  return (
    <div className="flex flex-col md:flex-row md:items-center gap-4">
      <div className={groupClass}>
        <span className="text-content-400 font-medium whitespace-nowrap">
          From:
        </span>
        <div className={fieldClass}>{from}</div>
      </div>

      <HugeiconsIcon
        icon={ArrowRight02Icon}
        size={16}
        className="text-content-200 hidden md:block"
      />

      <div className={groupClass}>
        <span className="text-content-400 font-medium whitespace-nowrap">
          To:
        </span>
        <div className={fieldClass}>{to}</div>
      </div>
    </div>
  );
};
